import { Tools } from '@babylonjs/core';
import { DoubleTouchBase, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { moveByPanning } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';

export const DoubleTouchPanning: DoubleTouchBase = {
  type: 'DoubleTouch',
  touchCount: 2,
  key: 'DoubleTouch',
  name: 'DoubleTouchPanning',
  option: {},
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  checkCondition(_camera: ZEDCamera, touchData: TouchData[]) {
    const t1 = touchData[0];
    const t2 = touchData[1];
    if (!t1 || !t2) return false;

    if (t1.dragVector.cosSimilarity(t2.dragVector) < 0.5) {
      return false;
    }

    return true;
  },
  onTouchStart(camera, touchData, _canvasProps) {
    const t1 = touchData[0];
    const t2 = touchData[1];
    if (!t1 || !t2) return;
    if (camera.beta < Tools.ToRadians(60)) {
      camera.xAxisPanningLock = false;
      camera.yAxisPanningLock = true;
      camera.zAxisPanningLock = false;
    } else {
      camera.xAxisPanningLock = false;
      camera.yAxisPanningLock = false;
      camera.zAxisPanningLock = false;
    }
  },
  onTouchMoved(camera, touchData, canvasProps) {
    const t1 = touchData[0];
    const t2 = touchData[1];
    if (!t1 || !t2) return;
    moveByPanning(camera, t1.movement, canvasProps);
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {},
};
